var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshIconDual(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.649,
    height: 16.017,
    viewBox: "0 0 17.649 16.017",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "refresh-svgrepo-com",
    transform: "translate(-1.09 -2.1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3065",
    "data-name": "Path 3065",
    d: "M9.954,2.25A7.4,7.4,0,0,0,2.625,9.093H1.853a.6.6,0,0,0-.557.381.626.626,0,0,0,.133.672l1.35,1.369a.594.594,0,0,0,.849,0l1.35-1.369a.626.626,0,0,0,.133-.672.6.6,0,0,0-.557-.381H3.836a6.129,6.129,0,0,1,11.372-2.62.6.6,0,0,0,.829.2.624.624,0,0,0,.2-.847A7.329,7.329,0,0,0,9.954,2.25Z",
    transform: "translate(0)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3066",
    "data-name": "Path 3066",
    d: "M17.523,10.428a.594.594,0,0,0-.848,0L15.32,11.8a.626.626,0,0,0-.134.672.6.6,0,0,0,.558.382h.723A6.162,6.162,0,0,1,5.046,15.469a.6.6,0,0,0-.83-.2.624.624,0,0,0-.2.848A7.362,7.362,0,0,0,17.678,12.85h.777a.6.6,0,0,0,.558-.382.625.625,0,0,0-.134-.672Z",
    transform: "translate(-0.479 -1.727)",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.3
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIconDual);
export default __webpack_public_path__ + "static/media/refresh-icon-dual.400d7621c879ebb2232885bbd25b37e8.svg";
export { ForwardRef as ReactComponent };